import React, { useState, useEffect } from "react";
import { Layout, Menu } from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  ShoppingCartOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import "./Styles/Layout.css"; // Assuming you have a CSS file for styling
import Dashboard from "./Dashboard";
import CommissionManagement from "./CommissionManagement.js";
import OrdersManagement from "./OrdersManagement";
import Reports from "./Reports.js";
import AdminReports from "./AdminReports.js";
import ReportsManagement from "./ReportsManagement.js";

const { Sider, Content } = Layout;

const App = () => {
  const [currentPage, setCurrentPage] = useState("dashboard");
  const [userRole, setUserRole] = useState(""); // State to hold user role
  useEffect(() => {
    if (currentPage === "addproducts") {
      window.location.href = "https://aptope.com/my-account/";
    }
  }, [currentPage]);

  useEffect(() => {
    const Role = localStorage.getItem("role");
    console.log(Role);
    setUserRole(Role);
  }, []);

  const handleMenuClick = (page) => {
    setCurrentPage(page.key);
  };

  return (
    <Layout style={{ minHeight: "92.1vh", width: "100%" }}>
      <Sider
        width="250"
        style={{ height: "100vh", overflow: "auto", paddingTop: 20 }}
      >
        <div className="logo" />
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[currentPage]}
          onClick={handleMenuClick}
        >
          <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
            Dashboard
          </Menu.Item>

          <Menu.Item key="orders" icon={<UserOutlined />}>
            Order Management
          </Menu.Item>

          <Menu.Item key="orderhistory" icon={<ShoppingCartOutlined />}>
            Orders History
          </Menu.Item>

          <Menu.Item key="reports" icon={<UserOutlined />}>
            Report Management
          </Menu.Item>
          {userRole === "admin" && (
            <Menu.Item key="commission" icon={<UserOutlined />}>
              Commission Management
            </Menu.Item>
          )}

          <Menu.Item key="addproducts" icon={<BarChartOutlined />}>
            Add Product
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Content style={{ margin: "16px" }}>
          {currentPage === "dashboard" && <Dashboard />}
          {currentPage === "orders" && <OrdersManagement />}
          {currentPage === "orderhistory" &&
            (userRole === "admin" ? <AdminReports /> : <Reports />)}
          {currentPage === "addproducts" && <Dashboard />}
          {currentPage === "reports" && <ReportsManagement />}
          {currentPage === "commission" &&
            (userRole === "admin" ? <CommissionManagement /> : "")}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
